import _ from 'lodash';
import React from 'react';

import Admin from './Admin';
import Alerts from './Alerts';
import ASDA from './ASDA';
import Daas from './Daas';
import Dashboard from './Dashboard';
import DeliveryTools from './DeliveryTools';
import DistManagement from './DistManagement';
import ExtAdmin from './ExtAdmin';
import Fcap from './Fcap';
import FleetManagement from './FleetManagement';
import Freight from './Freight';
import FulfilManagement from './FulfilManagement';
import GIF from './GIF';
import GM from './GM';
import GroceryTools from './Grocery';
import Inventory from './Inventory';
import NextGenPrinting from './NextGenPrinting';
import OfferLogistics from './OfferLogistics';
import OMS from './OMS';
import Prism from './Prism';
import ReturnOverride from './ReturnOverride';
import Returns from './Returns';
import ReverseLogistics from './ReverseLogistics';
import RPO from './RPO';
import Score from './Score';
import Sortation from './Sortation';
import Sourcing from './Sourcing';
import Swarm from './Swarm';
import Tipping from './Tipping';
import TrackAndTrace from './TrackAndTrace';
import Transport from './Transport';

const GscopeIconsList = [
    'grocery-b15x',
    'Alerts-b15x',
    'admin-b15x',
    'EA-415x',
    'DM-b15x',
    'OL-b15x',
    'returns-b15x',
    'PS-b15x',
    'Shipping-18',
    'OM-b15x',
    'IM-b15x',
    'Dash-b15x',
    'Configuration-181x',
    'FOCI-b15x',
    'GM-b15x',
    'Shuffle-18',
    'ReturnsOver-b15x',
    'PL-b15x',
    'FM-b15x',
    'Score-b15x',
    'FC-b15x',
    'Asda-w15x',
    'prism-w-Copy15x',
    'RPO-b15x',
    'Del-b15x',
    'GIF-b15x',
    'Trans-b15x',
    'TrackTrace-b',
    'Rev-b15x',
    'swarm-b15x',
    'Tip-b15x',
];

const iconMap = {
    'grocery-b15x': (props) => <GroceryTools {...props} />,
    'Alerts-b15x': (props) => <Alerts {...props} />,
    'admin-b15x': (props) => <Admin {...props} />,
    'EA-415x': (props) => <ExtAdmin {...props} />,
    'DM-b15x': (props) => <DistManagement {...props} />,
    'OL-b15x': (props) => <OfferLogistics {...props} />,
    'returns-b15x': (props) => <Returns {...props} />,
    'PS-b15x': (props) => <Sourcing {...props} />,
    'Shipping-18': (props) => <Transport {...props} />,
    'OM-b15x': (props) => <OMS {...props} />,
    'IM-b15x': (props) => <Inventory {...props} />,
    'Dash-b15x': (props) => <Dashboard {...props} />,
    'Configuration-181x': (props) => <DeliveryTools {...props} />,
    'FOCI-b15x': (props) => <FulfilManagement {...props} />,
    'GM-b15x': (props) => <GM {...props} />,
    'Shuffle-18': (props) => <Sortation {...props} />,
    'ReturnsOver-b15x': (props) => <ReturnOverride {...props} />,
    'PL-b15x': (props) => <NextGenPrinting {...props} />,
    'FM-b15x': (props) => <Freight {...props} />,
    'Score-b15x': (props) => <Score {...props} />,
    'FC-b15x': (props) => <Fcap {...props} />,
    'Asda-w15x': (props) => <ASDA {...props} />,
    'prism-w-Copy15x': (props) => <Prism {...props} />,
    'RPO-b15x': (props) => <RPO {...props} />,
    'Del-b15x': (props) => <Daas {...props} />,
    'GIF-b15x': (props) => <GIF {...props} />,
    'Trans-b15x': (props) => <FleetManagement {...props} />,
    'TrackTrace-b': (props) => <TrackAndTrace {...props} />,
    'Rev-b15x': (props) => <ReverseLogistics {...props} />,
    'swarm-b15x': (props) => <Swarm {...props} />,
    'Tip-b15x': (props) => <Tipping {...props} />,
};

const GscopeIcons = (props) => {
    const getIcon = _.get(iconMap, [props.name], null);
    return getIcon && typeof getIcon === 'function' ? getIcon(props) : null;
};

export { GscopeIconsList, GscopeIcons };
